import { render, staticRenderFns } from "./YouTubeVideo.vue?vue&type=template&id=30e601f5&lang=pug&"
import script from "./YouTubeVideo.vue?vue&type=script&lang=js&"
export * from "./YouTubeVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30e601f5')) {
      api.createRecord('30e601f5', component.options)
    } else {
      api.reload('30e601f5', component.options)
    }
    module.hot.accept("./YouTubeVideo.vue?vue&type=template&id=30e601f5&lang=pug&", function () {
      api.rerender('30e601f5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/video/YouTubeVideo.vue"
export default component.exports